import { useTranslator } from '@picsart/rc/services/localization';
import useStyles from './styles';
import { ErrorText } from '../constants';

const ErrorContent = () => {
  const classes = useStyles();
  const translate = useTranslator();

  return (
    <div className={classes.root} data-testid="error">
      <span>{translate(ErrorText)}</span>
    </div>
  );
};

export default ErrorContent;
